module.exports = __webpack_public_path__ + "media/images/pic/picaro-617ac807fbd6a87f6743350cb48a3dae.svg";